"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
var react_1 = __importDefault(require("react"));
var hooks_1 = require("../../../mantine-hooks/src");
var theme_1 = require("../../../mantine-theme/src");
var InputWrapper_1 = require("../InputWrapper/InputWrapper");
var Input_1 = require("../Input/Input");
var ChevronIcon_1 = require("./ChevronIcon");
function Select(_a) {
    var id = _a.id, className = _a.className, required = _a.required, label = _a.label, error = _a.error, style = _a.style, data = _a.data, placeholder = _a.placeholder, themeOverride = _a.themeOverride, wrapperProps = _a.wrapperProps, inputStyle = _a.inputStyle, description = _a.description, elementRef = _a.elementRef, others = __rest(_a, ["id", "className", "required", "label", "error", "style", "data", "placeholder", "themeOverride", "wrapperProps", "inputStyle", "description", "elementRef"]);
    var theme = theme_1.useMantineTheme(themeOverride);
    var uuid = hooks_1.useId(id);
    var options = data.map(function (item) { return (react_1.default.createElement("option", { key: item.value, value: item.value, disabled: item.disabled }, item.label)); });
    if (placeholder) {
        options.unshift(react_1.default.createElement("option", { key: "placeholder", value: "", selected: true, disabled: true, hidden: true }, placeholder));
    }
    var chevron = (react_1.default.createElement(ChevronIcon_1.ChevronIcon, { style: { color: error ? theme.colors.red[6] : theme.colors.gray[6] } }));
    return (react_1.default.createElement(InputWrapper_1.InputWrapper, __assign({}, wrapperProps, { required: required, id: uuid, label: label, error: error, className: className, style: style, themeOverride: themeOverride, description: description }),
        react_1.default.createElement(Input_1.Input, __assign({}, others, { component: "select", invalid: !!error, style: inputStyle, "aria-required": required, elementRef: elementRef, id: uuid, inputStyle: inputStyle, rightSection: chevron, rightSectionProps: { style: { pointerEvents: 'none' } }, required: required, themeOverride: themeOverride }), options)));
}
exports.Select = Select;
Select.displayName = '@mantine/core/Select';
